import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6ef2d3ca&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=6ef2d3ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2d3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef2d3ca')) {
      api.createRecord('6ef2d3ca', component.options)
    } else {
      api.reload('6ef2d3ca', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6ef2d3ca&scoped=true", function () {
      api.rerender('6ef2d3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/bond/detail.vue"
export default component.exports